import { useSelector } from 'react-redux';

import { areUserRolesIn } from '../../helpers';
import { Roles } from '../../constants';

import type { RootState } from '../../store';

// Whether the current user may manage a payor's modifier matrix. Wraps the Redux
// read so the page component stays free of direct `useSelector` use.
export const useCanManageModifiers = (): boolean => {
  const { user } = useSelector((state: RootState) => state.auth);

  return areUserRolesIn(user?.roles, [Roles.Admin, Roles.Biller]);
};
